// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { SliderTokens } from './type';

const sliderTokens: SliderTokens = {
  sliderFontSize: '12/regular',
  sliderTrackSize: 'Size-2',
  sliderTrackBackgroundColor: 'Neutral-fill-2',
  sliderTrackActiveBackgroundColor: 'Brand-6',
  sliderTrackDisabledBackgroundColor: 'Neutral-fill-4',
  sliderIndicatorSize: 'Size-6',
  sliderIndicatorBackgroundColor: 'Neutral-fill-1',
  sliderIndicatorBorderColor: 'Brand-6',
  sliderIndicatorBorderSize: 'Border-2',
  sliderIndicatorActiveBackgroundColor: 'Brand-6',
  sliderIndicatorActiveShadow: 'Shadow-1',
  sliderIndicatorDisabledBorderColor: 'Neutral-border-2',
  sliderIndicatorDisabledBackgroundColor: 'Neutral-fill-1',
  sliderValueBackgroundColor: 'Neutral-fill-1',
  sliderValueHoverBackgroundColor: 'Neutral-fill-9',
  sliderValueHoverFontColor: 'Neutral-text-1',
  sliderValueHoverRadius: 'Radius-2',
  sliderValueHoverPaddingX: 'Padding-8',
  sliderValueHoverPaddingY: 'Padding-3',
  sliderScaleLineSize: 'Size-3',
  sliderScaleLineBackgroundColor: 'Neutral-border-1',
  sliderScaleMarginY: 'Margin-4',
  sliderScaleFontColor: 'Neutral-text-4',
  sliderScaleFontSize: '12/regular',
};

export default sliderTokens;
